// extracted by mini-css-extract-plugin
module.exports = {"tableCheck":"dialog-table-check--tableCheck--3GxtaSs"};